import BaseBehavior from '../../../framework/base/base';
import { showElement } from '../../../shared/utilities/show-hide';
import * as verticalLoopAnim from '../../../shared/utilities/vertical-loop-animation';

export const Constants = {
	elementHeight: 82,
	animationDuration: 1
};
export default class TrustElement extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.previousItemId = 0;
		this.currentItemId = 1;
		this.getApiResponse();
	}

	getAllItems = (container, item) => container.querySelectorAll(item);

	createAndrenderFallbackView() {
		this.element.querySelectorAll('script').forEach(script => {
			const elementType = script.dataset?.type;
			if (elementType === 'static') {
				this.dom.fallbackView.insertAdjacentHTML('afterbegin', script.innerHTML);
			}
		});
		this.renderReviewsData(true);
	}

	getApiResponse() {
		const externalApi = this.element.dataset?.api;
		if (!externalApi) this.createAndrenderFallbackView();
		else {
			fetch(externalApi)
				.then(response => {
					if (!response.ok) {
						throw new Error('Some error in API');
					}
					return response.json();
				})
				.then(response => {
					this.createDomForAllItems(response);
					this.renderReviewsData(false);
				})
				.catch(e => {
					// eslint-disable-next-line no-console
					console.error(e);
					this.createAndrenderFallbackView();
				});
		}
	}

	createDomForAllItems(response) {
		this.element.querySelectorAll('script').forEach(script => {
			const elementType = script.dataset?.type;
			if (elementType === 'static') {
				this.dom.container.insertAdjacentHTML('afterbegin', script.innerHTML);
			} else if (elementType === 'external') {
				const metadata = JSON.parse(script.textContent || null);
				this.renderExternalElement(this.dom.container, metadata, response[metadata.type]);
			}
		});
	}

	renderReviewsData(isFallback) {
		const container = isFallback ? this.dom.fallbackView : this.dom.container;
		if (this.getAllItems(container, '.trust-element__item').length > 1) {
			verticalLoopAnim.setupForLoopAnimation.call(this, container, '.trust-element__item');
			this.addEventListeners(container);
		}
		this.totalItems = this.getAllItems(container, '.trust-element__item').length;
		this.currentItemId = this.totalItems - 1;
		container.style.transform = `translateY(-${(this.totalItems - 2) * Constants.elementHeight}px)`; // since we are cloning 2 nodes
		showElement(container);
		if (this.totalItems > 1) this.runAnimation(container);
	}

	renderExternalElement(container, metadata, response) {
		const starValue = response?.Stars;
		const ratingValue = response?.Rating;
		const pathStarValue = starValue?.split('.').join('_') || null;
		if (ratingValue) {
			const ratingRenderData = `
			<div class="trust-element__item trust-element__external-element">	
				${
					metadata.link
						? `<a class="v2-flexbox wrapper" href="${metadata.link}" target="_blank">`
						: '<div class="v2-flexbox wrapper">'
				}					
				<div>
					<img src="${metadata?.icon}" alt="${metadata?.type}-icon"/>
				</div>
				${`<div class="rating-section">
						<div class="text v2-text-align--left">
							${metadata?.ratingText || '&nbsp;'}
						</div>											
							<div class="v2-flexbox v2-align--middle">
								<span class="rating-value v2-mar8">${ratingValue}</span>
								<img class="rating-stars" src="${
									metadata?.iconStarBasePath
								}${pathStarValue}-star.svg" alt="Rating is ${starValue} on ${metadata?.type}" />
							</div>																																											
					</div>`}							
				${metadata?.link ? `</a>` : '</div>'}
			</div>`;
			container.insertAdjacentHTML('afterbegin', ratingRenderData);
		}
	}

	addEventListeners(container) {
		container.addEventListener('transitionend', () => {
			verticalLoopAnim.ontransitionendNew.call(
				this,
				[container],
				[Constants.elementHeight],
				this.totalItems
			);
		});
		container.addEventListener('mouseenter', () => {
			clearInterval(this.interval);
		});
		container.addEventListener('mouseleave', () => {
			this.updateStylesForAnimation(container); // to instant run on mousleave for one time
			this.runAnimation(container);
		});
	}

	updateStylesForAnimation(container) {
		this.previousItemId = this.currentItemId;
		this.currentItemId = this.currentItemId === 1 ? this.totalItems : this.currentItemId - 1;
		container.style.transition = `${Constants.animationDuration}s cubic-bezier(0.7, 0, 0.20, 1)`;
		container.style.transform = `translateY(-${
			(this.currentItemId - 1) * Constants.elementHeight
		}px)`;
	}

	runAnimation(container) {
		this.interval = setInterval(() => {
			this.updateStylesForAnimation(container);
		}, 4000);
	}

	cleanup() {
		this.removeEventListeners();
		clearInterval(this.interval);
	}

	removeEventListeners() {
		this.removeEventListener(this.dom.container, 'transitionend');
	}
}
